import themeColorsDesingSystem from "assets/theme/ds-colors";

const componentStyles = (theme) => ({
  card: {
    backgroundColor: themeColorsDesingSystem.transparent.dark,
  },
  cardHeader: {
    backgroundColor: "initial",
    borderBottom: "0!important",
  },
  cardContent: {
    [theme.breakpoints.up("md")]: {
      padding: "0 3rem",
    },
  },
  inputAdornedStart: {
    paddingLeft: 0,
  },
  inputAdornment: { marginRight: "0.75rem !important" },
  back: {
    margin: "1rem",
    color: themeColorsDesingSystem.white.main,
    fontWeight: 600,
    fontSize: 14,
    cursor: "pointer",
  },
  formControlLabelRoot: {
    position: "relative",
    display: "flex",
    minHeight: "1.5rem",
    WebkitPrintColorAdjust: "exact",
  },
  formControlLabelLabel: {
    cursor: "pointer",
    fontSize: ".875rem",
    position: "relative",
    verticalAlign: "top",
    display: "inline-block",
    color: themeColorsDesingSystem.white.main,
  },
  footerLinks: {
    color: themeColorsDesingSystem.white.main,
    textDecoration: "none",
    fontSize: "80%",
  },
});

export default componentStyles;
